export default "__VITE_ASSET__c4e2fc3b__"